import React from 'react';
import renderer from 'react-test-renderer';
import Zipcode from './';

it('should match snapshot', () => {
  const tree = renderer.create(<Zipcode />).toJSON();
  expect(tree).toMatchSnapshot();
});


// WEBPACK FOOTER //
// ./app/javascript/bundles/ui/Forms/Zipcode/index.test.jsx